import { useState } from "react";

export default function Faq() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    const faqCategories = [
        {
            title: "Generalidades y Suscripción",
            items: [
                {
                    q: "¿Qué es la IPTV y cómo funciona?",
                    a: "La IPTV (Televisión por Protocolo de Internet) es una tecnología que permite transmitir canales de televisión y contenidos de video a través de su conexión a internet, sin pasar por una antena satélite o cable tradicional. Con TVCIELO, accede instantáneamente a más de 79,000 canales y VOD simplemente conectando su dispositivo (Smart TV, Android Box, Smartphone) a internet."
                },
                {
                    q: "¿Qué dispositivos son compatibles con TVCIELO?",
                    a: "Nuestro servicio IPTV es compatible con casi todos los dispositivos conectados: Smart TV (Samsung, LG, Sony, Android TV, etc.), Android Boxes (Nvidia Shield, Xiaomi Mi Box), Fire TV Stick, Apple TV, Smartphones y Tablets (iOS y Android), PC/Mac (vía VLC o Smarters Pro) y los boxes MAG."
                },
                {
                    q: "¿Puedo usar mi suscripción en varias pantallas?",
                    a: "Sí, ofrecemos opciones multipantalla. Según su plan, puede ver sus programas en 1 o 2 dispositivos simultáneamente. Es ideal para compartir su suscripción con su familia o amigos."
                },
                {
                    q: "¿Ofrecen una prueba gratuita antes de la compra?",
                    a: "¡Absolutamente! Estamos convencidos de la calidad de nuestro servicio. Puede solicitar una prueba gratuita de 24h para verificar la estabilidad, la calidad de imagen (4K/FHD) y la riqueza de nuestro catálogo antes de comprometerse."
                }
            ]
        },
        {
            title: "Instalación y Técnica",
            items: [
                {
                    q: "¿Cómo instalar la IPTV en mi Smart TV?",
                    a: "La instalación es muy simple. Para Smart TV Samsung o LG, recomendamos la aplicación 'IPTV Smarters Pro' o 'IBO Player'. Una vez instalada la aplicación, solo necesita ingresar las credenciales (Xtream Codes o enlace M3U) que le enviamos por correo electrónico después de su pedido."
                },
                {
                    q: "¿Qué velocidad de internet es necesaria para 4K?",
                    a: "Para una experiencia fluida en 4K UHD, recomendamos una velocidad de conexión estable de al menos 25 Mbps. Para Full HD (1080p), 10 Mbps son suficientes. La fibra óptica es ideal, pero una buena conexión ADSL o 4G/5G también funciona muy bien."
                },
                {
                    q: "¿Qué hacer en caso de cortes o buffering?",
                    a: "Si experimenta ralentizaciones, primero verifique su conexión a internet (reinicie su router). Asegúrese de usar un cable Ethernet si es posible en lugar de Wi-Fi. Si el problema persiste, nuestro soporte técnico está disponible 7/7 para ayudarle a optimizar su configuración."
                },
                {
                    q: "¿Necesito un VPN para usar TVCIELO?",
                    a: "El uso de un VPN no es obligatorio pero puede ser recomendado si su proveedor de internet (ISP) limita su conexión durante el streaming. Nuestro servicio es compatible con todos los principales VPN del mercado (NordVPN, ExpressVPN, CyberGhost, etc.)."
                }
            ]
        },
        {
            title: "Pago y Soporte",
            items: [
                {
                    q: "¿Cuáles son los métodos de pago aceptados?",
                    a: "Aceptamos pagos seguros con Tarjeta Bancaria (Visa, Mastercard), PayPal y Criptomonedas (Bitcoin, USDT). Todas las transacciones están cifradas y seguras."
                },
                {
                    q: "¿En cuánto tiempo recibo mis accesos?",
                    a: "La entrega es automatizada y casi instantánea. Recibirá sus códigos de acceso y la guía de instalación por correo electrónico en los 5 a 15 minutos siguientes a la validación de su pago."
                },
                {
                    q: "¿Ofrecen una garantía de satisfacción o devolución?",
                    a: "Sí, ofrecemos una garantía de devolución de 7 días. Si encuentra problemas técnicos que nuestro soporte no puede resolver, le reembolsamos íntegramente."
                }
            ]
        }
    ];

    return (
        <section className="py-8">
            <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                <div className="text-center mb-10">
                    <span className="inline-block py-1 px-3 rounded-full bg-orange-400/10 border border-orange-400/20 text-orange-400 text-sm font-semibold mb-6">
                        CENTRO DE AYUDA
                    </span>
                    <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
                        Preguntas <span className="text-orange-400">Frecuentes</span>
                    </h1>
                    <p className="text-gray-400 text-lg max-w-2xl mx-auto">
                        Todo lo que necesita saber sobre nuestro servicio. Si no encuentra la respuesta a su pregunta, no dude en contactar nuestro soporte.
                    </p>
                </div>

                <div className="max-w-4xl mx-auto space-y-12">
                    {faqCategories.map((category, categoryIndex) => (
                        <div 
                            key={categoryIndex}
                            className="bg-white/5 backdrop-blur-xl rounded-3xl p-8 border border-white/10"
                        >
                            <h2 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
                                <span className="w-2 h-8 bg-orange-400 rounded-full"></span>
                                {category.title}
                            </h2>
                            <div className="space-y-2">
                                {category.items.map((item, itemIndex) => {
                                    const globalIndex = categoryIndex * 100 + itemIndex;
                                    const isOpen = openIndex === globalIndex;
                                    return (
                                        <div 
                                            key={itemIndex}
                                            className="border-b border-white/10 last:border-none"
                                        >
                                            <button
                                                type="button"
                                                onClick={() => toggle(globalIndex)}
                                                className="w-full py-6 flex items-center justify-between text-left group"
                                            >
                                                <span className={`text-lg font-medium transition-colors duration-300 ${isOpen ? 'text-orange-400' : 'text-white group-hover:text-orange-200'}`}>
                                                    {item.q}
                                                </span>
                                                <span className={`ml-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                                                    <svg 
                                                        xmlns="http://www.w3.org/2000/svg" 
                                                        className={`w-6 h-6 ${isOpen ? 'text-orange-400' : 'text-gray-400'}`}
                                                        fill="none" 
                                                        viewBox="0 0 24 24" 
                                                        stroke="currentColor"
                                                    >
                                                        <path 
                                                            strokeLinecap="round" 
                                                            strokeLinejoin="round" 
                                                            strokeWidth="2" 
                                                            d="M19 9l-7 7-7-7"
                                                        />
                                                    </svg>
                                                </span>
                                            </button>
                                            <div 
                                                className="overflow-hidden transition-all duration-300 ease-in-out"
                                                style={{
                                                    maxHeight: isOpen ? '500px' : '0',
                                                    opacity: isOpen ? 1 : 0
                                                }}
                                            >
                                                <div className="pb-6 text-gray-400 leading-relaxed">
                                                    {item.a}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-10">
                    <p className="text-gray-400 mb-6">
                        ¿No encuentra la respuesta que busca?
                    </p>
                    <a 
                        href="#contact"
                        className="bg-orange-400 hover:bg-orange-300 text-black font-bold px-8 py-3 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg inline-block"
                    >
                        Contactar el Soporte
                    </a>
                </div>
            </div>
        </section>
    );
}
